export const allCategory = "/category/find-all";
export const getparentCategory = "/category/get-parent-categories";
export const addCategoryEndpoint = "/category/create";
export const deleteCategory = "/category/delete";
export const updateCategoryById = "/category/update";
